import * as React from 'react';
import { useFormContext, Controller, ValidationRule } from 'react-hook-form';
import Select, { Props as IComponentProps } from 'client/components/Form/Select';
import get from 'lodash/get';
import { ISelectorOption } from 'types/ISelectorOption';

interface IProps<T extends unknown>
  extends Omit<IComponentProps<T>, 'errors' | 'onChange' | 'value'> {
  name: string;
  validate?: ValidationRule;
  defaultValue?: ISelectorOption;
}

const FormSelect = <T extends unknown>({
  name,
  defaultValue,
  validate,
  components,
  ...selectProps
}: IProps<T>) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      rules={validate}
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <Select
          {...selectProps}
          components={components}
          id={name}
          value={field.value}
          onChange={field.onChange}
          errors={get(errors, name)}
        />
      )}
    />
  );
};

export default FormSelect;
